
import {trigger, animate, style, group, animateChild, query, stagger, transition} from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
  transition('* <=> *', [
//     /* order */
//     /* 1 */ 
//     // query(':enter, :leave', style({ position: 'fixed', width:'100%' })
//     //   , { optional: true }),
//       query(':enter', [
//         style({ opacity: 0, position: 'fixed', width: '100%' }), 
//         animate('1s ease-in-out', style({ opacity: 1 }))
//       ], { optional: true }),
//       query(':leave', [
//         style({ opacity: 1, position: 'fixed', width: '100%' }),
//         animate('0.5s ease-in-out', style({ opacity: 0 }
//       ], { optional: true }),
//   ])
// ]);

           query(':leave', style({ position: 'absolute', left: 0, right: 0, opacity: 1 }), { optional: true }),
        query(':enter', style({ position: 'absolute', left: 0, right: 0, opacity: 0 }), { optional: true }),
        query(':leave', animate('0.7s', style({ opacity: 0 })), { optional: true }),
        query(':enter', animate('0.7s', style({ opacity: 1 })), { optional: true })

        ])

    ]);


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/fade.animation.ts